import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { TitlesForVerificationList } from "../titles-verification/TitlesForVerificationList";
import { TitleDetailPage } from "../titles-verification/TitleDetailPage";
import { TitleEdit } from "../titles-verification/TitleEdit";
import { RouteGuard } from "../../guards/RouteGuard";
function PeriodicalsForVerification() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, null,
                React.createElement(TitlesForVerificationList, { type: "PERIODICAL" }))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/detail/:id"), render: function () { return (React.createElement(RouteGuard, null,
                React.createElement(TitleDetailPage, { type: "PERIODICAL" }))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, null,
                React.createElement(TitleEdit, { type: "PERIODICAL" }))); } })));
}
export default PeriodicalsForVerification;
